import { useTranslation } from 'react-i18next'
import { Span } from '@/components/atoms'
import { FileDocumentIcon } from '@/components/atoms/icons/file'
import { TrashEmptyIcon } from '@/components/atoms/icons/interface'

interface SelectedFileListProps {
  files: File[]
  onRemove: (index: number) => void
  className?: string
}

export function SelectedFileList({
  files,
  onRemove,
  className = '',
}: SelectedFileListProps) {
  const { t } = useTranslation()

  if (!files.length) return <></>

  return (
    <ul className={`flex flex-col gap-2 ${className}`}>
      {files.map((file, index) => (
        <li
          key={`${file.name}-${file.lastModified}-${index}`}
          className="flex items-center gap-3 rounded-lg border border-neutral-100 bg-white px-4 py-3"
        >
          <FileDocumentIcon className="size-5 shrink-0 text-neutral-600" />
          <Span className="flex-1 truncate text-neutral-900">{file.name}</Span>
          <button
            type="button"
            aria-label={t('common.fileUpload.remove')}
            onClick={() => onRemove(index)}
            className="hover:text-error-base text-neutral-600 transition"
          >
            <TrashEmptyIcon className="size-5" />
          </button>
        </li>
      ))}
    </ul>
  )
}
